/**
 * Ported from jQuery: https://zurb.com/playground/responsive-tables
 */
import debounce from 'lodash.debounce'

const BREAKPOINT = 768

let $tables = Array.from(document.querySelectorAll('.js-responsive-table'))

let switched = false
function updateTables () {
  if (window.innerWidth < BREAKPOINT && !switched) {
    switched = true
    $tables.forEach(splitTable)
    return true
  } else if (switched && window.innerWidth >= BREAKPOINT) {
    switched = false
    $tables.forEach(unsplitTable)
  }
}

updateTables()
// $(window).on("redraw", function() {
//   switched = false;
//   updateTables();
// });
// $(window).on("resize", updateTables);
window.addEventListener('resize', updateTables)

function splitTable ($table) {
  let $wrapper = document.createElement('div')
  $wrapper.className = 'table-wrapper'
  wrap($table, $wrapper)

  let $copy = $table.cloneNode(true)
  Array.from(
    $copy.querySelectorAll('td:not(:first-child), th:not(:first-child)')
  ).forEach($x => ($x.style.display = 'none'))

  $copy.classList.remove('table-responsive')

  $table.closest('.table-wrapper').appendChild($copy)
  let $wrapper2 = document.createElement('div')
  $wrapper2.className = 'table-pinned'
  wrap($copy, $wrapper2)

  let $wrapper3 = document.createElement('div')
  $wrapper3.className = 'table-scrollable'
  $wrapper3.addEventListener(
    'scroll',
    debounce(onScroll, 100, { leading: true, trailing: true })
  )
  wrap($table, $wrapper3)
  onScroll({ target: $wrapper3 })

  setCellHeights($table, $copy)
}

function unsplitTable ($table) {
  let $pinned = $table.closest('.table-wrapper').querySelector('.table-pinned')
  $pinned.parentNode.removeChild($pinned)
  unwrap($table.parentNode)
  unwrap($table.parentNode)
}

function setCellHeights ($table, $copy) {
  let tr = Array.from($table.querySelectorAll('tr'))
  let trCopy = Array.from($copy.querySelectorAll('tr'))
  let heights = []

  tr.forEach(($t, index) => {
    let tx = Array.from($t.querySelectorAll('th, td'))

    tx.forEach($x => {
      let height = $x.offsetHeight
      heights[index] = heights[index] || 0
      if (height > heights[index]) heights[index] = height
    })
  })

  trCopy.forEach(($t, index) => {
    $t.style.height = `${heights[index]}px`
  })
}

function wrap ($el, $wrapper) {
  $el.parentNode.insertBefore($wrapper, $el)
  $wrapper.appendChild($el)
}

function unwrap ($el) {
  let $parent = $el.parentNode
  while ($el.firstChild) $parent.insertBefore($el.firstChild, $el)
  $parent.removeChild($el)
}

function onScroll (e) {
  let $wrapper = e.target.closest('.table-wrapper')

  if (e.target.scrollLeft > 0) {
    $wrapper.classList.add('has-overflow-left')
  } else {
    $wrapper.classList.remove('has-overflow-left')
  }

  if (e.target.scrollWidth - e.target.scrollLeft === e.target.clientWidth) {
    $wrapper.classList.remove('has-overflow-right')
  } else {
    $wrapper.classList.add('has-overflow-right')
  }
}



// WEBPACK FOOTER //
// ./src/js/_table.js